import { connect } from 'react-redux'
import RequestTimeSettings from '../../components/trips/RequestTimeSettings'
import * as actions from '../../state/actions/trips'
import { IStoreState } from '../../types'

export function mapStateToProps(state: IStoreState, ownProps: any): any {
  const tripRequest = state.tripRequest || { request: {} }
  const request = tripRequest.request
  return {
    request,
    scheduledPickupTime: request.scheduledPickupTime,
    leaveAtDateTime: request.leaveAtDateTime,
    arriveByDateTime: request.arriveByDateTime,
    scheduledDropoffTime: request.scheduledDropoffTime,
    willCall: request.willCall,
    refreshAvailableProducts: ownProps.refreshAvailableProducts,
    scheduledReturn: request.scheduledReturn,
    returnPickupTime: request.returnPickupTime
  }
}

export function mapDispatchToProps(dispatch: any) {
  return {
    setScheduledTime: (time: string, type: string) => {
      if (type === 'pickup') {
        return Promise.all([
          dispatch(actions.actionCreators.setDropoffToTripRequest()),
          dispatch(actions.actionCreators.setPickupToTripRequest(time)),
          dispatch(actions.actionCreators.setRecurringDropoffTime()),
          dispatch(actions.actionCreators.setRecurringPickupTime())
        ])
      } else if (type === 'leave-at') {
        return Promise.all([
          dispatch(actions.actionCreators.setDropoffToTripRequest()),
          dispatch(actions.actionCreators.setPickupToTripRequest()),
          dispatch(actions.actionCreators.setLeaveAtToTripRequest(time)),
          dispatch(actions.actionCreators.setArriveByToTripRequest()),
          dispatch(actions.actionCreators.setRecurringDropoffTime()),
          dispatch(actions.actionCreators.setRecurringPickupTime())
        ])
      } else if (type === 'arrive-by') {
        return Promise.all([
          dispatch(actions.actionCreators.setDropoffToTripRequest()),
          dispatch(actions.actionCreators.setPickupToTripRequest()),
          dispatch(actions.actionCreators.setLeaveAtToTripRequest()),
          dispatch(actions.actionCreators.setArriveByToTripRequest(time)),
          dispatch(actions.actionCreators.setRecurringDropoffTime()),
          dispatch(actions.actionCreators.setRecurringPickupTime())
        ])
      } else if (type === 'dropoff') {
        return Promise.all([
          dispatch(actions.actionCreators.setDropoffToTripRequest(time)),
          dispatch(actions.actionCreators.setLeaveAtToTripRequest()),
          dispatch(actions.actionCreators.setArriveByToTripRequest()),
          dispatch(actions.actionCreators.setPickupToTripRequest()),
          dispatch(actions.actionCreators.setRecurringDropoffTime()),
          dispatch(actions.actionCreators.setRecurringPickupTime())
        ])
      } else if (type === 'recurPickup') {
        return Promise.all([
          dispatch(actions.actionCreators.setDropoffToTripRequest()),
          dispatch(actions.actionCreators.setLeaveAtToTripRequest()),
          dispatch(actions.actionCreators.setArriveByToTripRequest()),
          dispatch(actions.actionCreators.setPickupToTripRequest()),
          dispatch(actions.actionCreators.setRecurringDropoffTime()),
          dispatch(actions.actionCreators.setRecurringPickupTime(time))
        ])
      } else if (type === 'recurDropoff') {
        return Promise.all([
          dispatch(actions.actionCreators.setDropoffToTripRequest()),
          dispatch(actions.actionCreators.setLeaveAtToTripRequest()),
          dispatch(actions.actionCreators.setArriveByToTripRequest()),
          dispatch(actions.actionCreators.setPickupToTripRequest()),
          dispatch(actions.actionCreators.setRecurringDropoffTime(time)),
          dispatch(actions.actionCreators.setRecurringPickupTime())
        ])
      } else {
        return Promise.all([
          dispatch(actions.actionCreators.setDropoffToTripRequest()),
          dispatch(actions.actionCreators.setLeaveAtToTripRequest()),
          dispatch(actions.actionCreators.setArriveByToTripRequest()),
          dispatch(actions.actionCreators.setPickupToTripRequest()),
          dispatch(actions.actionCreators.setRecurringDropoffTime()),
          dispatch(actions.actionCreators.setRecurringPickupTime())
        ])
      }
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RequestTimeSettings)



// WEBPACK FOOTER //
// ./src/containers/trips/RequestTimeSettings.ts